import {configContainer, utils} from '@wallaby-ui/core';
import {autoLayoutContainer} from '@wallaby-ui/document';
import {isEqual} from 'lodash';
import * as React from 'react';
import {defineMessages} from 'react-intl';
import {TabPanel} from 'react-tabs';

import stylesLayout from './AppLayout.less';

const I18N = defineMessages({
  TITLE: {
    id: 'document.items.title',
    defaultMessage: 'DOCUMENT ITEMS',
    description: 'title text for document items box',
  },
  HELP: {
    id: 'document.items.help',
    defaultMessage: 'This box is showing the document items.',
    description: 'help text for document items box',
  },
});

const DocumentScreenTabPanel = {
  contextParams: {},

  renderTabPanel(key, props) {
    const {config, contextParams, docId, intl} = props;
    const newContextParams = {
      ...contextParams,
      docId: contextParams && contextParams.docId ? contextParams.docId : docId,
    };
    if (!isEqual(DocumentScreenTabPanel.contextParams, newContextParams)) {
      DocumentScreenTabPanel.contextParams = newContextParams;
    }
    return (
      <TabPanel
        className={{
          'react-tabs__tab-panel': true,
          [stylesLayout.dlTabColumn]: true,
        }}
        key={key}
      >
        <autoLayoutContainer.DynamicAutoLayoutContainer
          autoLayoutStateId={autoLayoutContainer.AUTO_LAYOUT_REDUCER_STATE_ID}
          config={config}
          configStateId={configContainer.CONFIG_REDUCER_STATE_ID}
          titleText={utils.TranslateUtils.translate(I18N.TITLE, intl)}
          helpText={utils.TranslateUtils.translate(I18N.HELP, intl)}
        />
        <autoLayoutContainer.AutoLayoutLoaderContainer
          autoLayoutStateId={autoLayoutContainer.AUTO_LAYOUT_REDUCER_STATE_ID}
          config={config}
          configStateId={configContainer.CONFIG_REDUCER_STATE_ID}
          contextParams={DocumentScreenTabPanel.contextParams}
          isDynamic
        />
      </TabPanel>
    );
  },
};

DocumentScreenTabPanel.displayName = 'DocumentScreenTabPanel';

export default DocumentScreenTabPanel;
